import type {RecoInfo} from '@/modules/common/hooks/useRecommendations/models';
import type {
  BD4TravelEcommerceItem,
  BD4TravelElement,
  EventAction,
  EventActionCreator,
  EventHandler,
  Recommendation,
} from '@/redux/middleware/googleTagManager/types';

import {EVENT_BD4_RECOMMENDED_CLICKED} from '@/redux/middleware/googleTagManager/actionTypes';
import {mapHotelRecommendedDataToEcommerceElement} from '@/redux/middleware/googleTagManager/utils/mapHotelRecommendedDataToEcommerceElement';
import {mapHotelRecommendedDataToEcommerceItem} from '@/redux/middleware/googleTagManager/utils/mapHotelRecommendedDataToEcommerceItem';
import {waitForGtmDomEvent} from '@/redux/middleware/googleTagManager/utils/waitForGtmDomEvent';

type Payload = {
  hotel: Recommendation;
};

type Action = EventAction<Payload>;

type NullEvent = {
  ecommerce: null;
};

type Event = {
  event: string;
  event_action: string;
  non_interaction: boolean;
  list_offset: number;
  list_position: number;
  ecommerce: {
    items: [BD4TravelEcommerceItem];
  };
  elements: BD4TravelElement;
  recoInfo: RecoInfo;
};

export const action: EventActionCreator<Action, Payload> = (payload) => ({
  type: EVENT_BD4_RECOMMENDED_CLICKED,
  payload,
});

export const handler: EventHandler<
  Action,
  Promise<[NullEvent, Event]>
> = waitForGtmDomEvent<[NullEvent, Event], Payload>((eventAction) => {
  const {hotel} = eventAction.payload;

  return [
    {ecommerce: null},
    {
      event: 'select_promotion',
      event_action: 'BD4_recommender_clicked',
      non_interaction: false,
      // the zero-based index of the first visible item - will be fixed to 0
      list_offset: 0,
      list_position: hotel.index,
      ecommerce: {
        promotion_name: 'BD4 recommender',
        items: [mapHotelRecommendedDataToEcommerceItem(hotel)],
      },
      elements: mapHotelRecommendedDataToEcommerceElement(hotel),
      recoInfo: hotel.recoInfo,
    },
  ];
});
